import { FunctionComponent, ReactNode } from 'react'
import contextToiTeaser from '@contexts/toiTeaser'
import { TeaserMainTextAlignment, ArticleType } from './types'
import { TeaserParentFlex } from '../types'
import { computeFlex } from '../utils'
import { computeRatio } from './utils'

interface TOITeaserLayoutContextProvider {
  teaserParentFlex: TeaserParentFlex
  hasParentGrid: boolean
  mainTextPositionV: TeaserMainTextAlignment['v']
  mainTextPositionH: TeaserMainTextAlignment['h']
  accentColor: string
  isInMegaModule: boolean
  articleType: ArticleType
  children?: ReactNode
}

const { TOITeaserLayoutContext } = contextToiTeaser

const TOITeaserLayoutContextProvider: FunctionComponent<
  TOITeaserLayoutContextProvider
> = ({
  teaserParentFlex,
  hasParentGrid,
  mainTextPositionV,
  mainTextPositionH,
  accentColor,
  isInMegaModule,
  articleType,
  children,
}) => {
  const teaserFlex = computeFlex({
    parentFlex: teaserParentFlex,
    hasParentGrid,
  })
  const teaserRatio = computeRatio(teaserFlex)
  const mainTextAlignment = { v: mainTextPositionV, h: mainTextPositionH }

  return (
    <TOITeaserLayoutContext.Provider
      value={{
        isInMegaModule,
        accentColor,
        mainTextAlignment,
        teaserFlex,
        teaserRatio,
        articleType,
      }}>
      {children}
    </TOITeaserLayoutContext.Provider>
  )
}

export default TOITeaserLayoutContextProvider
